import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class ProductService extends RestfulService<Models.Product> {

  constructor(private restService: RestService) {
    super(Models.Product);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('products');
  }

}

